class IPreferenceStore {
    setPreference(name, value) {
    }

    getPreference(name) {
        return null;
    }

    removePreference(name) {
    }
}

export default IPreferenceStore;